import { render } from "./EmployeeRejectedPayments.vue?vue&type=template&id=1bea54d0"
import script from "./EmployeeRejectedPayments.vue?vue&type=script&lang=js"
export * from "./EmployeeRejectedPayments.vue?vue&type=script&lang=js"

import "./EmployeeRejectedPayments.vue?vue&type=style&index=0&id=1bea54d0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__